export const SINGLE_PROPS = {
  fetchSuggestions: Function,
  labelKeys: Array,
}



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/props/single.js